import React from 'react';
import moment from 'moment';

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {debugger;
        return (
            <div className="custom-tooltip" style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '10px' }}>
                <p className="label">{`Entry Time : ${moment(payload[0].payload["BUY TIME"]).format('HH:mm:ss')}`}</p>
                <p className="intro">{`Profit/Loss : ${payload[0].value.toFixed(2)}`}</p>
                <p className="intro">{`Points Gain : ${payload[0].payload["POINTS GAIN"].toFixed(2)}`}</p>
            </div>
        );
    }

    return null;
};

export default CustomTooltip;
